import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import React from "react";
import MergeSubTopic from "./MegeSubTopic";

interface Props {
  mergeTopic: server.dto.AvailableMergeFieldTopic
  onSelect: (mergefield: string) => void
}

const MergeTopic = (props: Props) => {
  return <CollapsibleSection
    title={props.mergeTopic.label}
    uniqueRowId={props.mergeTopic.label}
    collapsible="startClosed"
  >
    <div className="flex-column gap">
      {props.mergeTopic.subTopics.map((subTopic, id) => (
        <MergeSubTopic
          key={id}
          subtopic={subTopic}
          onSelect={props.onSelect}
        />
      ))}
    </div>
  </CollapsibleSection>
};

export default MergeTopic;